import * as actions from "./legalCase.actions";
import * as api from "./legalCase.api";
import { BASE_PATH_ENTITY, ENTITY, REDUCER_KEY } from "./legalCase.constants";
import * as hooks from "./legalCase.hooks";
import * as promises from "./legalCase.promises";
import reducer from "./legalCase.reducer";
import { saga } from "./legalCase.saga";
import * as selectors from "./legalCase.selectors";
import * as utils from "./legalCase.utils";
export var REDUCER_KEY_LEGAL_CASE = REDUCER_KEY;
export var legalCaseModule = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    reducerState: {},
    actions: actions,
    api: api,
    hooks: hooks,
    promises: promises,
    reducer: reducer,
    saga: saga,
    selectors: selectors,
    utils: utils,
};
